import message from 'antd/lib/message';
import 'antd/lib/message/style/css';
export default message;



// WEBPACK FOOTER //
// ./src/components/common/message/index.js